import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { Alert, Card, CardBody } from 'reactstrap';
import { formatBytes } from '../../utils/formatBytes';
import { resolveTicketingApiUrl } from '../../utils/ticketingApiUrl';

function getAuthToken() {
  return Cookies.get('accessToken') || Cookies.get('jwtToken');
}

export default function AttachmentList({ ticketId, attachments = [] }) {
  const [error, setError] = useState(null);
  const [downloadingId, setDownloadingId] = useState(null);

  if (!attachments.length) return null;

  const handleDownload = async (attachment) => {
    const url = resolveTicketingApiUrl(
      attachment.downloadUrl || `/v1/tickets/${ticketId}/attachments/${attachment.attachmentId}/download`
    );
    const token = getAuthToken();
    setError(null);
    setDownloadingId(attachment.attachmentId);
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!response.ok) {
        const text = await response.text().catch(() => '');
        let message = 'Download failed';
        try {
          const json = JSON.parse(text);
          message = json.message || json.error || message;
        } catch {
          if (text) message = text;
        }
        throw new Error(message);
      }
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.download = attachment.filename || 'attachment';
      anchor.rel = 'noopener';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      setError(err?.message || 'Download failed');
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <Card className="mt-2">
      <CardBody>
        <h5 className="mb-3">Attachments</h5>
        {error && (
          <Alert color="danger" toggle={() => setError(null)} className="mb-2">
            {error}
          </Alert>
        )}
        <ul className="mb-0 ps-3">
          {attachments.map((a) => (
            <li key={a.attachmentId} className="mb-1">
              <button
                type="button"
                className="btn btn-link p-0 align-baseline"
                onClick={() => handleDownload(a)}
                disabled={downloadingId === a.attachmentId}
                aria-label={`Download ${a.filename}`}
              >
                {downloadingId === a.attachmentId ? 'Downloading…' : a.filename}
              </button>
              {a.sizeBytes != null && (
                <span className="text-muted small ms-1">
                  ({formatBytes(a.sizeBytes)})
                </span>
              )}
            </li>
          ))}
        </ul>
      </CardBody>
    </Card>
  );
}
